(function () {
  var THRESHOLD = (window.GO_FSB && window.GO_FSB.threshold) || 10000;
  var TRUCK = '<svg class="go-fsb__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5h10.5v7H3z"/><path d="M13.5 10h3.6L21 13v1.5h-7.5z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
  var CHECK = '<svg class="go-fsb__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.3 12.4l2.4 2.4 4.9-5.2"/></svg>';
  function fmt(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function msg(total) {
    var remaining = THRESHOLD - total, done = remaining <= 0;
    return (done ? CHECK : TRUCK) + '<span>' + (done
      ? '<strong>Free shipping unlocked.</strong> Nice.'
      : 'You’re <strong>' + fmt(remaining) + '</strong> away from <strong>free shipping</strong>') + '</span>';
  }
  function build() {
    var b = document.createElement('div');
    b.className = 'go-fsb';
    b.setAttribute('role', 'status');
    b.innerHTML = '<p class="go-fsb__msg"></p><div class="go-fsb__track"><div class="go-fsb__fill"></div></div>';
    return b;
  }
  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function fillColor(pct) {
    var t = pct / 100;
    return 'rgb(' + lerp(124, 0, t) + ', ' + lerp(192, 86, t) + ', ' + lerp(232, 119, t) + ')';
  }
  function paint(bar, total) {
    var pct = Math.max(0, Math.min(total / THRESHOLD, 1) * 100);
    var done = (THRESHOLD - total) <= 0;
    bar.classList.toggle('go-fsb--done', done);
    bar.querySelector('.go-fsb__msg').innerHTML = msg(total);
    var fill = bar.querySelector('.go-fsb__fill');
    fill.style.width = pct.toFixed(1) + '%';
    fill.style.background = done ? '#15b06a' : fillColor(pct);
  }
  var busy = false;
  function spots() {
    var out = [];
    var inner = document.querySelector('.drawer__inner');
    if (inner) out.push({ box: inner, anchor: inner.querySelector('.drawer__header') });
    document.querySelectorAll('#main-cart-items .js-contents').forEach(function (jc) {
      out.push({ box: jc, anchor: null });
    });
    return out;
  }
  function place(total) {
    busy = true;
    spots().forEach(function (s) {
      var bar = s.box.querySelector('.go-fsb');
      if (total <= 0) { if (bar) bar.remove(); return; }
      if (!bar) {
        bar = build();
        if (s.anchor && s.anchor.nextSibling) s.box.insertBefore(bar, s.anchor.nextSibling);
        else if (s.anchor) s.box.appendChild(bar);
        else s.box.insertBefore(bar, s.box.firstChild);
      }
      paint(bar, total);
    });
    setTimeout(function () { busy = false; }, 80);
  }
  var t;
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { place(c.total_price); })
      .catch(function () {});
  }
  function ping() { clearTimeout(t); t = setTimeout(refresh, 140); }
  function start() {
    refresh();
    var o = new MutationObserver(function () { if (!busy) ping(); });
    ['CartDrawer', 'main-cart-items'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) o.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', refresh);
})();
